import { Typography, Box, Container } from '@mui/material';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

      <ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="container subPageContainer">
          <Typography variant='h1' className='sectionTitle'>Impressum</Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>Angaben gemäß § 5 DDG</Typography>
          <Typography variant='body1' className='sectionText'>
            Notare Dr. Antonia Harbecke und Dr. Martin Konstantin Thelen<br />
            Holzgasse 29-33<br />
            53721 Siegburg
          </Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>Aufsichtsbehörde</Typography>
          <Typography variant='body1' className='sectionText'>
            Präsident des Landgerichts Bonn<br />
            Wilhelmstraße 21, 53111 Bonn <br /><br />
            Präsident des Oberlandesgerichts Köln<br />
            Reichenspergerplatz 1, 50670 Köln
          </Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>Berufsbezeichnung und besondere berufliche Regelungen</Typography>
          <Typography variant='body1' className='sectionText'>
            Berufsbezeichnung: Notar<br />
            Kammer: Rheinische Notarkammer<br /><br />

            Burgmauer 53, 50667 Köln<br />

            Verliehen in: Bundesrepublik Deutschland<br /><br />

            Der Berufsstand Notar / Notarin unterliegt den unter https://www.notar.de/der-notar/berufsrecht genannten berufsrechtlichen Regelungen.
          </Typography>


          <Typography variant='h2' className='sectionTitle3 marginTop'>Verantwortliche</Typography>
          <Typography variant='body1' className='sectionText'>
            Notare Dr. Antonia Harbecke und Dr. Martin Konstantin Thelen <br />
            Holzgasse 29-33 <br />
            53721 Siegburg
          </Typography>


        </Container>


        <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white small'>
                                                Sie haben Fragen?  <br />
                                                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Öffnungszeiten</b><br />
                                                Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch ab 13:00 Uhr geschlossen<br />
                                                Spätere Termine sind nach Vereinbarung möglich<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Telefon</b><br />
                                                Sie erreichen uns unter: 02241 66444<br />
                                                Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch nur bis 13:00 Uhr. <br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Fax: 02241 55161</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Anfahrt und Parkmöglichkeiten</b><br />
                                                Das Büro befindet sich im Zentrum von Siegburg in der Holzgasse Nr. 29 – 33. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. <br />
                                                Parkmöglichkeiten befinden sich u.a. im Parkhaus Holzgasse in unmittelbare Nähe zu den Kanzleiräumlichkeiten sowie im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt.
                                            </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>

      </main >
      <Footer />
    </div >
  );
}

export default Imprint;